/**
 * List of all html hooks.
 *
 * @type {Function[]}
 */
const register = [];

/**
 * Register a new html hook.
 *
 * @param {Function} callback
 */
export function registerHtmlHook(callback) {
    if (typeof callback !== "function") {
        console.warn('callback should be a function!');
        return;
    }

    register.push(callback);
}

/**
 * Execute hooks for given node.
 *
 * @param {Node} container
 */
export function executeHtmlHooks(container) {
    register.forEach((callback) => callback(container));
}
